import React, { useState, useEffect, useContext } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import ChatInput from "../Chat/ChatInput";
import { Images } from "../../assets/common";
import { SocketContext } from "../../context/socket";
import Picker from "emoji-picker-react";

import cookieStorage from "../../services/cookie-storage";
import Message from "../Chat/Message";
import {
  fullName,
  getErrorString,
  getUserDetail,
} from "../../constants/function";
import TipPopup from "../TipPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch } from "react-redux";
import notifier from "../Notifier";
import ApiService from "../../services/api-service";
import Loader from "../Loader";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import { SkinTones } from 'emoji-picker-react';

export default function StreamingChat({
  playlistId,
  isOwner,
  closeFullscreen,
  leaveStreaming,
  streamData,
  artistId,
  isSubscribed,
}) {
  const { t } = useTranslation("common");
  const [typing, setTyping] = React.useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const userData = getUserDetail();

  const socket = useContext(SocketContext).Socket;
  const token = cookieStorage.getCookie("Authorization");
  const [openTip, setOpenTip] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [newMessage, setNewMessage] = useState({});
  const [openEmoji, setOpenEmoji] = useState(false);
  const [hideChat, setHideChat] = useState(false);

  

  useEffect(() => {
    getBlockedUserOfPlaylist(playlistId);
  }, []);

  // Join the chat room, and join again after a reconnect that did not recover the session
  useEffect(() => {
    if (!socket) return;
    const joinRoom = () =>
      socket.emit("join", { JWT: cookieStorage.getCookie("Authorization"), roomId: playlistId });
    const rejoinRoom = () => {
      if (!socket.recovered) joinRoom();
    };
    joinRoom();
    socket.on("connect", rejoinRoom);
    return () => {
      socket.off("connect", rejoinRoom);
    };
  }, [socket, playlistId]);

useEffect(() => {
  if (artistId && isSubscribed) {
    // Implement additional logic here if needed
  }
}, [artistId, isSubscribed]);
  


  const handleEnterPress = (event) => {
    if (event.keyCode === 13) {
      sendMessage();
    }
  };

  const onKeyup = (event) => {
    setMessage(event.target.value);
    if (event.keyCode === 13) {
      handleEnterPress(event);
    }
  };
  const showLocalChatMessage = (text) => {
    setNewMessage({
      roomId: playlistId,
      senderUserId: userData._id,
      message: text,
      _id: new Date().getTime(),
      createdAt: new Date(),
      isStreaming: true,
      user: {
        firstName: userData["firstName"],
        lastName: userData["lastName"],
        profileImg: userData["profileImg"],
        _id: userData["_id"],
        isVerified: userData["isVerified"],
      },
    });
  };

  const handleClipCommand = async (text) => {
    const parts = text.trim().split(/\s+/);
    const arg = parts[1];
    let duration = arg ? parseInt(arg, 10) : 60;

    if (!Number.isFinite(duration) || duration < 5) {
      showLocalChatMessage("Usage: /clip [seconds] — between 5 and 600 (default 60)");
      return;
    }
    if (duration > 600) duration = 600;

    const channelName = streamData?._id || playlistId;
    const livestreamId = streamData?._id;
    const studioId = playlistId;

    if (!channelName || !studioId) {
      showLocalChatMessage("Cannot create clip: stream not ready");
      return;
    }

    const stamp = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    const title = `${streamData?.title || "Livestream"} clip — ${stamp}`;

    showLocalChatMessage(`Creating ${duration}s clip…`);

    try {
      await ApiService.CREATE_CLIP({
        channelName,
        startOffset: duration,
        duration,
        title,
        studioId,
        livestreamId,
      });
      showLocalChatMessage(`Clip created (${duration}s) — "${title}"`);
    } catch (e) {
      showLocalChatMessage(`Clip failed: ${getErrorString(e) || "unknown error"}`);
    }
  };

  const sendMessage = () => {
    const trimmed = message.trim();
    if (trimmed === "") return;

    if (/^\/clip(\s|$)/i.test(trimmed)) {
      setMessage("");
      if (isOwner) handleClipCommand(trimmed);
      return;
    }

    const msg = {
      roomId: playlistId,
      senderUserId: userData._id,
      message: message,
      _id: userData["_id"],
      JWT: token,
      isStreaming: true,
      user: {
        firstName: userData["firstName"],
        lastName: userData["lastName"],
        profileImg: userData["profileImg"],
        _id: userData["_id"],
        isVerified: userData["isVerified"],
      },
    };

    setMessage("");
    if (socket) socket.emit("chat_message", msg);

    msg["user"] = {
      firstName: userData["firstName"],
      lastName: userData["lastName"],
      profileImg: userData["profileImg"],
      _id: userData["_id"],
      isVerified: userData["isVerified"],
    };
    msg["_id"] = new Date().getTime();
    msg["createdAt"] = new Date();

    setNewMessage({ ...msg });
  };
  const handleTip = async (amount, id, type, currency) => {
    if (amount) {
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: "livestreamArtist",
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_PLAYLIST(payload);

        setLoading(false);
        notifier.success(response["result"]);
        // setUserName(null);
        dispatch(getBalance());

        // Broadcast tip message to chat
        const msg = {
          isStreaming: true,
          roomId: playlistId,
          senderUserId: userData._id,
          amount: amount,
          message: `${fullName(
            userData
          )} has tipped ${amount} ${currency.toUpperCase()} to the stream`,
          _id: userData._id,
          JWT: token,
          type: "tip",
          user: {
            firstName: userData["firstName"],
            lastName: userData["lastName"],
            profileImg: userData["profileImg"],
            _id: userData["_id"],
            isVerified: userData["isVerified"],
          },
        };

        if (socket) socket.emit("chat_message", msg);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const onEmojiClick = (emojiObject, eventemojiObject) => {
    if (emojiObject && emojiObject.emoji) {
        setMessage((prevMessage) => prevMessage + emojiObject.emoji);
    } else {
    }
};
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      setStatus(response?.result?.isBlocked ? "blocked" : "active");
    } catch (error) {
      console.warn('[StreamingChat] Failed to fetch blocked user status:', error);
    }
  };

  useEffect(() => {
    if (!socket) return;
    const handleBlocked = (data) => {
        if (data.userId === userData._id && playlistId === data.roomId) {
          setStatus(data["status"]);
          if (data["status"] === "blocked") {
            leaveStreaming();
          }
        }
    };
    socket.on("blocked", handleBlocked);
      // socket.on("notifyTyping", (msg) => {
      //   if (
      //     msg &&
      //     msg["senderUserId"] &&
      //     msg["senderUserId"] !== userData._id &&
      //     msg["roomId"] === playlistId
      //   ) {
      //     setTyping(msg["senderUserId"]);
      //     setTimeout(() => setTyping(false), 500);
      //   }
      // });
    return () => socket.off("blocked", handleBlocked);
  }, [socket]);


  

  return (
    <Box
      className="_streaming_chat"
      sx={{
        background: hideChat ? "none !important" : "initial",
        height: hideChat ? "50px !important" : "initial",
        minHeight: hideChat ? "50px !important" : "initial",
      }}
    >
      <Stack
        sx={{ height: "inherit" }}
        spacing={1}
        className={hideChat ? " _hide_messages" : ""}
      >
        {openEmoji ? (
          <OutsideClickHandler onOutsideClick={() => setOpenEmoji(false)}>
            <Picker
              pickerStyle={{ zIndex: "1" }}
              skinTone={SkinTones.MEDIUM_LIGHT}
              onEmojiClick={onEmojiClick}
              // native={true}
            />
          </OutsideClickHandler>
        ) : null}
        <Message
          isStream={true}
          roomId={playlistId}
          playListId={playlistId}
          type={"group"}
          senderUserId={userData._id}


          newMessage={newMessage}
          onChangeStatus={(status) => {
            setStatus(status);
          }}
        />
        
        <Box className="__chat_typing_streaming">
        </Box>
      </Stack>
      {status === "blocked" ? (
        <Stack
          direction="row"
          justifyContent="center"
          align="center"
          className="__chat_send"
        >
          <Typography
            sx={{
              color: "#5a5a5a",
              display: "flex",
              alignItems: "center",
              cursor: "default",
            }}
          >
            {"Blocked from owner"}
          </Typography>
        </Stack>
      ) : (
        <Stack
          className="_streaming_chat_input"
          alignItems="center"
          direction="row"
        >
          <input
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            onKeyUp={(e) => onKeyup(e)}
            type="text"
            placeholder={isOwner ? "Type your message (or /clip 60)" : "Type your message"}
          />
          <Stack direction="row" alignItems="center" spacing={1}>
            <img
              aria-label="emoji"
              title="Open emoji"
              className="_cp"
              style={{ width: "26px" }}
              src={Images.emoji}
              alt="emoji"
              onClick={() => {
                setOpenEmoji(true);
              }}
            />
            {!isOwner ? (
              <img
                title="Tip playlist"
                className="_cp"
                onClick={() => {
                  setOpenTip(true);
                  // closeFullscreen();
                }}
                style={{ width: "24px" }}
                src={Images.tip_player}
                alt=""
              />
            ) : null}
            <IconButton onClick={() => setHideChat(!hideChat)}>
              <img
                className={hideChat ? "_arrow_up_chat" : "_arrow_down_chat"}
                style={{ width: "12px", height: "12px" }}
                src={Images.arrow_down}
                alt="arrow_down"
              />
            </IconButton>
            {/* {isOwner ? (
            <img
              className={"_cp "}
              style={{ width: "24px" }}
              src={Images.GIFT}
              alt=""
            />
          ) : null} */}
          </Stack>
        </Stack>
      )}
      {openTip ? (
        <TipPopup
          artist={streamData?.title}
          id={artistId || streamData?.owner || streamData?.createdBy || streamData?.createdByDetails?._id}
          open={openTip}
          isArtist={true}
          isPlaylist={false}
          handleClose={handleTip}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={t("loader.message12")}
        />
      ) : null}
    </Box>
  );
}